<template>
    <div class="main-content login-main-content h-100vh">
        <div class="container h-100">
            <div class="row h-100 align-items-center justify-content-center">

                <div class="col-md-6">
                    <section class="login-side">
                        <img src="./mer.png" alt="">
                    </section>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-5">
                    <!-- Middle Box -->
                    <div class="middle-box">
                        <div class="">
                            <div class="p-4">

                                <!-- Logo -->
                                <div class="d-flex justify-content-center">
                                    <div class="w-100 text-center">


                                        <p class="login-title">MERBROK SA</p>
                                        <div class="login-separator mx-auto"></div>
                                        <p class="login-welcome-message">Por favor, ingrese su usuario y contraseña para
                                            iniciar sesión</p>
                                    </div>
                                </div>

                                <form action="#">
                                    <div class="form-group">

                                        <vs-input :state="(error) ? 'danger' : ''" v-model="fillLogin.cEmail"
                                            placeholder="Correo Electronico" @keyup.enter="login()">
                                            <template #icon>
                                                <i class='fas fa-user-tie'></i>
                                            </template>
                                        </vs-input>

                                    </div>

                               <!--div class="form-group">
                            <vs-input
                                :state="(error) ? 'danger' : ''"
                                :type="mostrarPassword ? 'text' : 'password'"
                                @keyup.enter="login()"
                                v-model="fillLogin.cContrasena"
                                placeholder="Contraseña"
                                autocomplete="current-password">

                                <template #icon>
                                    <i class='fas fa-lock' style="margin-right: 8px;"></i>
                                    <i :class="mostrarPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                                    @click="mostrarPassword = !mostrarPassword"
                                    style="cursor: pointer; pointer-events: auto;">
                                    </i>
                                </template>
                            </vs-input>
                        </div-->
                    <div class="form-group" style="position: relative;"> <a href="" class="text-dark float-right"></a>

                        <vs-input
                            :state="(error) ? 'danger' : ''"
                            :type="mostrarPassword ? 'text' : 'password'"
                            @keyup.enter="login()"
                            v-model="fillLogin.cContrasena"
                            placeholder="Contraseña"
                            autocomplete="current-password">

                            <template #icon>
                                <i class='fas fa-lock'></i>
                            </template>
                        </vs-input>

                        <i :class="mostrarPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                        @click="mostrarPassword = !mostrarPassword"
                        style="position: absolute; right: 10px; top: 10px; cursor: pointer; z-index: 10; color: #666; pointer-events: auto;">
                        </i>
                    </div>


                                    <div class="form-group mb-0">
                                        <button class="btn login-btn-submit btn-block" @click.prevent="login()"> Ingresar
                                        </button>
                                    </div>



                            <div class="text-center mt-2">
                                <a href="#" @click.prevent="modalRecuperar = true" class="text-muted">¿Olvidó su contraseña?</a>
                            </div>

                            <vs-dialog v-model="modalRecuperar" prevent-close>
                                <template #header>
                                    <h4 class="not-margin">Recuperar Contraseña</h4>
                                </template>

                                <div class="con-form">
                                    <p>Ingrese su correo electrónico para recibir una nueva contraseña.</p>
                                    <vs-input v-model="emailRecuperar" placeholder="Correo Electrónico" block>
                                        <template #icon><i class='fas fa-envelope'></i></template>
                                    </vs-input>
                                </div>

                                <template #footer>
                                    <div class="footer-dialog">
                                        <vs-button @click="enviarNuevaClave()" :loading="loadingRecuperar" block>
                                            Enviar Nueva Contraseña
                                        </vs-button>
                                    </div>
                                </template>
                            </vs-dialog>



                                </form>

                                <!-- end card -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
import { alertasM } from '../../../util.js';
import "./login.css";
export default {
    data() {

        return {
            fillLogin: {
                cEmail: '',
                cContrasena: ''
            },
            error: 0,
            mensajeError: [],
            listRolPermisosByUsuario: [],
            listRolPermisosByUsuarioFilter: [],
            mostrarPassword: false,
            //nuevas variables
            modalRecuperar: false,
            emailRecuperar: '',
            loadingRecuperar: false,
        }
    },
    mixins: [alertasM],
    methods: {
        //Nos logeamos
        login() {
            if (this.validarLogin()) {

                for (var key in this.mensajeError) {
                    this.notify(" " + this.mensajeError[key], "", "top", "center", "fas fa-exclamation-triangle", "danger", 'animated fadeInDown', 'animated fadeOutDown')
                }
                return;
            }
            const loading = this.$vs.loading({
                type: 'square',
                //color: '#D5397B',
                //// background: '#FFFFFF',
                text: 'Cargando...'
            });//Cargando
            var url = '/authenticate/login'
            axios.post(url, {
                'cEmail': this.fillLogin.cEmail,
                'cContrasena': this.fillLogin.cContrasena
            }).then(response => {

                //console.log(response.data)

                if (response.data.code == 401) {
                    this.notify(" Credenciales Incorrectas", "", "top", "center", "fas fa-user-lock", "danger", 'animated fadeInDown', 'animated fadeOutDown');
                    this.error = 1;
                }
                if (response.data.code == 200) {

                    this.getListarRolPermisosByUsuario(response.data.authUser);
                    this.config();
                    //this.getListarRolPermisosByUsuario(response.data.authUser)
                }
                loading.close()
                /* setTimeout(() => {
                    loading.close()
                }, 2000) */
            }).catch(err => {
                loading.close()//Desactivamos ventana de carga de bloqueo

                console.error(err);
            })
        },

        //Validamos datos
        validarLogin() {
            this.error = 0;
            this.mensajeError = [];

            if (!this.fillLogin.cEmail) {
                this.mensajeError.push('El correo electronico es un campo obligatorio');
            }
            if (!this.fillLogin.cContrasena) {
                this.mensajeError.push('La contraseña es un campo obligatorio')
            }
            if (this.mensajeError.length) {
                this.error = 1;
            }
            return this.error;
        },
        //Listamos permisos del rol y user
        getListarRolPermisosByUsuario(authUser) {
            var ruta = '/administracion/usuario/getListarRolPermisosByUsuario'
            axios.get(ruta, {
                params: {
                    'id': authUser.id
                }
            }).then(response => {
                this.listRolPermisosByUsuario = response.data;//Guardamos la data en un array
                this.filterListarRolPermisosByUsuario(authUser);
            })
        },
        //Filtramos y solo guardamos la url amigable
        filterListarRolPermisosByUsuario(authUser) {
            let me = this;
            me.listRolPermisosByUsuario.map(function (x, y) {
                me.listRolPermisosByUsuarioFilter.push(x.slug)
            })
            //localStorage Guardamos informacion del cliente en el navegador
            localStorage.setItem('listRolPermisosByUsuario', JSON.stringify(me.listRolPermisosByUsuarioFilter));
            localStorage.setItem('authUser', JSON.stringify(authUser));
            this.loginSuccess();//recargamos y redirige al inicio
        },
        //Recargamos y redirigimos al inicio
        loginSuccess() {
            this.$router.push({ name: 'login' })
            location.reload();
        },

        config() {
            var ruta = '/config'
            axios.get(ruta)
                .then(res => {

                    localStorage.setItem('listarConfig', JSON.stringify(res.data.config[0]));
                })
                .catch(err => {
                    console.error(err);
                })
        },
        enviarNuevaClave() {
        if (!this.emailRecuperar) {
            this.notify("Ingrese su correo por favor", "", "top", "center", "fas fa-exclamation", "warning");
            return;
        }
        this.loadingRecuperar = true;
        axios.post('/recuperar-password', { email: this.emailRecuperar })
            .then(res => {
                this.notify("Contraseña enviada con éxito", "Revise su correo", "top", "center", "fas fa-check", "success");
                this.modalRecuperar = false;
                this.emailRecuperar = '';
            })
            .catch(err => {
                let msg = err.response.data.message || "Error al procesar";
                this.notify(msg, "", "top", "center", "fas fa-times", "danger");
            })
            .finally(() => { this.loadingRecuperar = false; });
        }

    },
}
</script>
